var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMasterDevice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 209,
    height: 209,
    viewBox: "0 0 209 209",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18629",
    "data-name": "Rectangle 18629",
    width: 83.363,
    height: 100,
    fill: "#0050ad"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_23597",
    "data-name": "Group 23597",
    transform: "translate(-314 -2078)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "INC_Cloud_1",
    transform: "translate(-773 417)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_943",
    "data-name": "Ellipse 943",
    transform: "translate(1087 1661)",
    fill: "#fff",
    stroke: "#0050ad",
    strokeWidth: 15
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 104.5,
    cy: 104.5,
    r: 104.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104.5,
    cy: 104.5,
    r: 97,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23595",
    "data-name": "Group 23595",
    transform: "translate(1150 1716)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23594",
    "data-name": "Group 23594",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50007",
    "data-name": "Path 50007",
    d: "M75.5,0a2.276,2.276,0,0,1,1.257,2.033c.468,5.674.981,11.345,1.477,17.016q.843,9.626,1.682,19.252.824,9.481,1.641,18.962.833,9.578,1.67,19.155c.073.842.129,1.689.13,2.534q.016,9.277.005,18.554c0,2.021-.465,2.494-2.445,2.494H2.5C.551,100,.055,99.52.058,97.6.067,91-.131,84.38.157,77.784c.284-6.495,1.064-12.968,1.626-19.45Q2.6,48.9,3.422,39.47q.846-9.724,1.693-19.447c.522-6,1.056-11.991,1.549-17.99A2.275,2.275,0,0,1,7.92,0ZM73.523,3.4H9.895Q6.57,41.718,3.253,79.946H80.178C77.957,54.4,75.744,28.938,73.523,3.4m6.453,80.018H3.458V96.592H79.977Z",
    transform: "translate(0)",
    fill: "#0050ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50008",
    "data-name": "Path 50008",
    d: "M62.884,82.942c.221-.367.423-.692.617-1.023q4.867-8.34,9.734-16.681c1.116-1.912,2.445-1.923,3.549-.028q4.885,8.386,9.765,16.775c.176.3.37.6.605.974,2.286-1.824,4.518-3.6,6.747-5.382q4-3.2,8.006-6.4a1.864,1.864,0,0,1,2.317-.38c.881.543.82,1.408.649,2.267-.545,2.741-1.108,5.479-1.656,8.219q-2.383,11.9-4.758,23.806c-.34,1.709-.727,2.044-2.491,2.044H54.08c-1.8,0-2.158-.317-2.519-2.123Q48.4,89.188,45.221,73.368c-.051-.255-.1-.512-.13-.769a1.669,1.669,0,0,1,.778-1.851,1.693,1.693,0,0,1,2,.229c1.126.885,2.239,1.785,3.357,2.68Q56.711,78.049,62.2,82.44c.2.159.41.3.685.5M54.7,103.75H95.326l.642-3.279h-2.55V97.128H96.65L100.8,76.372c-.363.263-.576.4-.775.564q-5.872,4.688-11.741,9.381c-1.574,1.259-2.417,1.109-3.427-.624q-4.615-7.919-9.229-15.84c-.173-.3-.363-.585-.612-.983-.249.4-.439.688-.613.986q-4.649,7.956-9.3,15.914c-.957,1.639-1.816,1.806-3.286.631q-5.832-4.66-11.661-9.325c-.256-.205-.527-.392-.931-.691l4.167,20.807h3.222v3.282H54.06l.644,3.276",
    transform: "translate(-33.305 -47.151)",
    fill: "#0050ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50009",
    "data-name": "Path 50009",
    d: "M75.406,335.634v-3.206h3.256v6.545H38.808v-6.539h3.237v3.2Z",
    transform: "translate(-28.682 -245.689)",
    fill: "#0050ad"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18622",
    "data-name": "Rectangle 18622",
    width: 6.516,
    height: 3.24,
    transform: "translate(60.115 88.371)",
    fill: "#0050ad"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18623",
    "data-name": "Rectangle 18623",
    width: 6.569,
    height: 3.184,
    transform: "translate(68.426 88.394)",
    fill: "#0050ad"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18624",
    "data-name": "Rectangle 18624",
    width: 3.207,
    height: 3.241,
    transform: "translate(40.096 50.045)",
    fill: "#0050ad"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18625",
    "data-name": "Rectangle 18625",
    width: 3.229,
    height: 3.205,
    transform: "translate(26.738 50.069)",
    fill: "#0050ad"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18626",
    "data-name": "Rectangle 18626",
    width: 3.199,
    height: 3.234,
    transform: "translate(33.422 50.047)",
    fill: "#0050ad"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18627",
    "data-name": "Rectangle 18627",
    width: 3.236,
    height: 3.18,
    transform: "translate(46.777 50.081)",
    fill: "#0050ad"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18628",
    "data-name": "Rectangle 18628",
    width: 3.221,
    height: 3.199,
    transform: "translate(53.456 50.053)",
    fill: "#0050ad"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_49986",
    "data-name": "Path 49986",
    d: "M-6240.577-104.6l-52.09,24.6s-1.1-13.266-5.057-13.953S-6240.577-104.6-6240.577-104.6Z",
    transform: "translate(6703.177 2365)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterDevice);
export default __webpack_public_path__ + "static/media/master-device.2a8f4e7da2e37a0fe7dc05dda9c6d916.svg";
export { ForwardRef as ReactComponent };